import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { TaskCategoryFeaturedBlockResource } from './resources';
import { OffsetPaginationInput } from '@app/data/inputs';
import {
    CreateTaskCategoryFeaturedBlockInput,
    TaskCategoryFeaturedBlockFilterInput,
    UpdateTaskCategoryFeaturedBlockInput,
} from './inputs';
import { TaskCategoryFeaturedBlockRef } from './refs';

export default class TaskCategoryFeaturedBlock {
    private basePath = '/api/task-category-featured-block';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task category featured block list
    getList = async (
        pagination: OffsetPaginationInput,
        filter?: TaskCategoryFeaturedBlockFilterInput,
    ): Promise<CollectionResource<TaskCategoryFeaturedBlockResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Create new task category featured block
    create = async (input: CreateTaskCategoryFeaturedBlockInput): Promise<TaskCategoryFeaturedBlockRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Fetch single task category featured block by ID
    getById = async (id: ID): Promise<TaskCategoryFeaturedBlockResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Update task category featured block
    update = async (id: ID, input: UpdateTaskCategoryFeaturedBlockInput): Promise<TaskCategoryFeaturedBlockRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archives task category featured block
    archive = async (id: ID): Promise<TaskCategoryFeaturedBlockRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);
        return data;
    };

    // Restores task category featured block
    restore = async (id: ID): Promise<TaskCategoryFeaturedBlockRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);
        return data;
    };
}
